import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid} from '@material-ui/core';
import BasicInput from 'Components/common/BasicInput';
import {adminLogin, validMobile, ssoLogin} from 'Actions/auth';
import {T} from 'Actions/translate';
import {openNotification} from 'Actions/notification';
import BasicButton from 'Components/common/BasicButton';
import {removeProfile, removeIdToken, loadIdToken} from 'Utils/jwtUtil';
import {updateProductSearchFields, updateCategroySelected} from 'Actions/order';
import {setSCData} from 'Actions/localData';
import LoadingIcon from 'Components/icons/LoadingIcon';
import {ssoGoUserCenterUrl} from 'Utils/urlUtil';
// import { setProfile } from 'Utils/jwtUtil';

const windowPath = window.location.href;
class Adminlogin extends Component {
    state = {
        userName: '',
        password: '',
    };

    componentWillMount() {
        const hasSSO = windowPath.includes('/purchase/sso');
        const hasTargetURL = windowPath.includes(
            '/purchase/sso/ltoHistoryList',
        );
        const hasTargetSelectCustomerURL = windowPath.includes(
            '/purchase/sso/selectCustomer',
        );

        const hasTargetUserCenterURL = windowPath.includes(
            '/purchase/sso/userCenter',
        );

        if (hasSSO) {
            this.props
                .ssoLogin(
                    {
                        hasTargetURL: hasTargetURL,
                        hasTargetSelectCustomerURL: hasTargetSelectCustomerURL,
                        hasTargetUserCenterURL: hasTargetUserCenterURL,
                    },
                    this.goToPurchaseOrder,
                )
                .catch((err) => {
                    // console.log("err=========================", err);
                });
        } else {
            removeIdToken();
            removeProfile();
            this.props.setSCData({
                id: null,
                name: null,
                type: null,
            });
            this.props.updateCategroySelected({
                key: 0,
                value: T('allProduct'),
            });
            this.props.updateProductSearchFields('');
        }
    }

    goToPurchaseOrder = (
        res,
        hasTargetURL,
        hasTargetSelectCustomerURL,
        hasTargetUserCenterURL,
    ) => {
        if (res.status === 'success') {
            if (hasTargetURL) {
                this.props.history.push('/purchase/ltoHistoryList');
            } else if (hasTargetSelectCustomerURL) {
                this.props.history.push('/purchase/selectCustomer');
            } else if (hasTargetUserCenterURL) {
                this.props.history.replace('/userCenter');
            } else {
                this.props.history.replace('/userCenter');
            }
        }
    };

    handleChange = (name, value) => {
        this.setState({[name]: value});
    };

    handleLogin = () => {
        if (this.state.userName && this.state.password) {
            this.props.adminLogin(
                {
                    userName: this.state.userName,
                    password: this.state.password,
                },
                this.goToOrderPage,
            );
        }
    };

    goToSSOLogin = () => {
        window.location.href = ssoGoUserCenterUrl;
    };

    goToOrderPage = (res) => {
        if (res.status === 'success') {
            // setProfile(res.data)
            if (!res.data.allowLoginMobile) {
                this.props.openNotification(T('role_incorrect'), 'danger');
            } else {
                switch (res.data.type) {
                    case 1:
                    case 2:
                    case 3:
                        this.props.history.replace('/userCenter');
                        break;
                    default:
                }

                if (res.data && res.data.type) {
                    if (res.data.type === 1) {
                        window.tfsUserID = 'internal_admin_' + res.data.id;
                    } else if (res.data.type === 2) {
                        window.tfsUserID = 'internal_host_' + res.data.id;
                    } else if (res.data.type === 3) {
                        window.tfsUserID = 'internal_sales_' + res.data.id;
                    }
                }
            }
        }
    };

    validMobile = () => {
        if (this.state.userName) {
            this.props.validMobile(this.state.userName);
        }
    };

    render() {
        const {mobileValid, adminUser} = this.props;
        const hasSSO = windowPath.includes('/purchase/sso');
        return hasSSO ? (
            adminUser && adminUser.message === 'invalid user email' ? (
                <div className="admin-not-permissions-login">
                    <h3 className="supply-center-name">{T('supplyCenter')}</h3>
                    <div>{T('welcome_to_website')}</div>
                    {T('user_account_unauthorized')}
                    <div className="unauthorized-info">
                        <a href={'mailto:' + T('unauthorized_connect_email')}>
                            {T('unauthorized_connect_email')}
                        </a>
                    </div>
                </div>
            ) : (
                <LoadingIcon className="circle-animation" />
            )
        ) : (
            <div className="admin-login">
                <Grid
                    className="login-title-en-container no-margin"
                    container
                    spacing={0}
                    justify={'space-evenly'}>
                    <Grid className="login-title-en" item md={8} xs={8}>
                        <span>{T('supplyCenter')}</span>
                    </Grid>
                </Grid>
                <Grid
                    className="login-title-cn-container no-margin"
                    container
                    spacing={0}
                    justify={'space-evenly'}>
                    <Grid className="login-title-cn" item md={8} xs={8}>
                        <span>{T('login')}</span>
                    </Grid>
                </Grid>

                <Grid
                    className="userName-container"
                    container
                    spacing={0}
                    justify={'space-evenly'}>
                    <Grid
                        className={
                            mobileValid.status !== 'invalid_mobile'
                                ? 'input-grid'
                                : 'input-grid mobile-valid'
                        }
                        item
                        md={8}
                        xs={8}>
                        <BasicInput
                            title={'userName'}
                            inputValid={this.handleChange}
                            placeholder={'enter_mobile'}
                            type="number"
                            testid="mobile-input-username"
                            blurAction={this.validMobile}
                        />
                    </Grid>
                </Grid>
                {mobileValid.status === 'invalid_mobile' ? (
                    <Grid container spacing={0} justify={'space-evenly'}>
                        <Grid className="input-grid" item md={8} xs={8}>
                            <span
                                className="error-msg"
                                testid="mobile-input-username-error">
                                {T('accountNotExit')}
                            </span>
                        </Grid>
                    </Grid>
                ) : null}

                <Grid
                    className="password-container"
                    container
                    spacing={0}
                    justify={'space-evenly'}>
                    <Grid
                        className={
                            adminUser && adminUser.status !== 'invalid_password'
                                ? 'input-grid'
                                : 'input-grid password-valid'
                        }
                        item
                        md={8}
                        xs={8}>
                        <BasicInput
                            title={'password'}
                            inputValid={this.handleChange}
                            placeholder={'enter_password'}
                            testid="mobile-input-password"
                            type="password"
                        />
                    </Grid>
                </Grid>
                {adminUser && adminUser.status === 'invalid_password' ? (
                    <Grid container spacing={0} justify={'space-evenly'}>
                        <Grid className="input-grid" item md={8} xs={8}>
                            <span
                                className="error-msg"
                                testid="mobile-input-password-error">
                                {T('password_not_valid')}
                            </span>
                        </Grid>
                    </Grid>
                ) : null}

                <Grid
                    className="button-container"
                    container
                    spacing={0}
                    justify={'space-evenly'}>
                    <Grid className="button-grid" item md={8} xs={8}>
                        <BasicButton
                            className="login-button"
                            testid="mobile-login-button"
                            disabled={false}
                            onClickOfSingleTap={this.handleLogin}>
                            {T('accountLoginLabel')}
                        </BasicButton>
                        <BasicButton
                            className="login-button sso-login-wrapper"
                            testid="mobile-sso-login-button"
                            disabled={false}
                            onClickOfSingleTap={this.goToSSOLogin}>
                            {T('ssoLoginLabel')}
                        </BasicButton>
                    </Grid>
                </Grid>

                <Grid
                    className="record-container"
                    container
                    spacing={0}
                    justify={'center'}>
                    <a href="https://beian.miit.gov.cn/">
                        {T('record_number')}
                    </a>
                    <span>|</span>
                    <a href="//www.thermofisher.com/cn/zh/home/global/licenses-cn.html">
                        {' '}
                        {T('business_license')}
                    </a>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {auth} = state;
    return {
        mobileValid: auth.mobileValid,
        adminUser: auth.adminUser,
    };
};

const mapDispatchToProps = {
    adminLogin,
    validMobile,
    updateProductSearchFields,
    updateCategroySelected,
    openNotification,
    setSCData,
    ssoLogin,
};

export default connect(mapStateToProps, mapDispatchToProps)(Adminlogin);
